var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _c(
        "van-cell-group",
        [
          _c("van-field", {
            attrs: {
              label: "用户名",
              placeholder: "请输入用户名",
              required: "",
            },
            model: {
              value: _vm.loginForm.username,
              callback: function ($$v) {
                _vm.$set(_vm.loginForm, "username", $$v)
              },
              expression: "loginForm.username",
            },
          }),
          _c("van-field", {
            attrs: {
              type: "password",
              label: "密码",
              placeholder: "请输入密码",
              required: "",
            },
            model: {
              value: _vm.loginForm.password,
              callback: function ($$v) {
                _vm.$set(_vm.loginForm, "password", $$v)
              },
              expression: "loginForm.password",
            },
          }),
          _c("van-field", {
            attrs: {
              label: "验证码",
              placeholder: "请输入验证码",
              required: "",
            },
            scopedSlots: _vm._u([
              {
                key: "button",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "captcha-image",
                      attrs: { src: _vm.codeUrl },
                      on: { click: _vm.getCode },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.loginForm.code,
              callback: function ($$v) {
                _vm.$set(_vm.loginForm, "code", $$v)
              },
              expression: "loginForm.code",
            },
          }),
        ],
        1
      ),
      _c(
        "van-button",
        {
          staticClass: "m-t-20",
          attrs: { type: "info", block: "" },
          on: { click: _vm.login },
        },
        [_vm._v("登录")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }